// extracted by mini-css-extract-plugin
export default {"dropdown":"base-dropdown_dropdown_JtFmk","container":"base-dropdown_container_cRRTz"};